import { Component, OnInit } from '@angular/core';
import { IMember } from 'app/shared/Domains/member';
import { Router } from '@angular/router';
import { AppServiceManager } from 'common/services/appServiceManager';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { MessageService, ConfirmationService } from 'primeng/api';
import { IMemberFeeDetails } from 'app/shared/Domains/feeDetail';
import { IMemberContact } from 'app/shared/Domains/memberContact';
import { ICompany } from 'app/shared/Domains/company';
import { AppUtils } from 'common/services/app.util';
import { Configuration } from "config/config";
import { IBranch } from 'app/shared/Domains/branch';
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
  selector: 'app-fees',
  templateUrl: './fees.component.html',
  styleUrls: ['./fees.component.css']
})
export class FeesComponent implements OnInit {
  member: IMember;
  members: IMember[];
  branch: IBranch;
  sourceMembers: IMember[];
  loading: boolean;
  fund: IMemberFeeDetails;
  dialogVisibility: boolean;
  company: ICompany;
  currentUserData:any;

  constructor(private LanguageService: LanguageService, public config: Configuration, private route: Router, private confirmationService: ConfirmationService, private messageService: MessageService, private appServiceManager: AppServiceManager, private breadcrumbService: BreadcrumbService) {
    this.breadcrumbService.setItems([
      { label: 'Member Account Management' },
      { label: 'All Member Acounts', routerLink: ['/accounts'] }
    ]);
  }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("FeesComponent", label);
  }
  ngOnInit() {
    this.member = new IMember();
    this.company = new ICompany();
    this.member.contactDetail = new IMemberContact();
    this.fund = new IMemberFeeDetails();
    this.members = [];
    this.sourceMembers = [];
    this.dialogVisibility = false;
    this.loading = true;
    let user = JSON.parse(localStorage.getItem('currentUser'));
    this.currentUserData = JSON.parse(localStorage.getItem('currentUser'));
    this.appServiceManager.get('customers/company/' + user.company).subscribe((res: any) => {
      if (res.length > 0) {
        this.members = res;
        this.sourceMembers = res;
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
      }
      this.loading = false;
      this.members = [...this.members]
    },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }
  search() {
    this.loading = true;
    this.appServiceManager.post('customers/search', this.member).subscribe((res: any) => {
      if (res.length > 0) {
        this.members = res;
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
      }
      this.loading = false;
      this.members = [...this.members]
    },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }
  viewMember(member) {
    this.route.navigateByUrl('account/' + member._id)
  }
  showDialog(member) {
    this.member = new IMember();
    this.member = member;
    this.fund.pay = parseInt(this.member.monthFee);
    this.dialogVisibility = true;
  }
  getCompany() {
    let user = JSON.parse(localStorage.getItem('currentUser'));
    this.appServiceManager.get('companies/' + user.company).subscribe((res) => {
      if (res) {
        this.company = res;
      } else {
        this.company = new ICompany();
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
      }
    },
      (error) => {
        this.company = new ICompany();
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }
  activityLogs(member) {
    member.currentUserData = this.currentUserData;
    member.type = 'Deactivate';
    member.scope = 'Member';
    member.initiatedFrom = 'fees';
    // Make an API call to log the activity
    this.appServiceManager.post('activityLogs/activityLogs', member).subscribe((logRes: any) => {
      // Handle the logging response here
    });
  }
  deleteMember(member) {
    this.confirmationService.confirm({
      message: "Are you sure you want to DeActivate member ?",
      accept: () => {
        this.loading = true;
        this.appServiceManager.delete('customers/' + member._id).subscribe((res: any) => {
          if (res.status === true) {
            this.activityLogs(member);
            this.DeleteMember(member);
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Successfully Deactivated' });
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
          this.loading = false;
          this.members = [...this.members]
        },
          (error) => {
            this.loading = false;
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
      }
    });
  }
  addFund() {
    this.dialogVisibility = false;
    this.confirmationService.confirm({
      message: "Are you sure you want to pay member monthly fee ?",
      accept: () => {
        if (this.fund.pay !== null && this.fund.pay > 0) {
          let date = new Date();
          this.fund.date = date;
          const currentDate = new Date();
          const currentMonth = currentDate.getMonth() + 1;
          const currentYear = currentDate.getFullYear();
          this.fund.invoice = AppUtils.generateInvoiceNo(this.member.tagNumber, this.member.feeDetails,  currentYear,  currentMonth);
          this.fund.status = "Monthly Fee - Paid";
          this.member.feeDetails.push(this.fund);
          this.member.type = 'pay member monthly fee';
          this.member.scope = 'Member';
          this.member.initiatedFrom = 'fees';
          this.member.memberSettingFlag = false;
          this.appServiceManager.put("customers/" + this.member._id, this.member).subscribe((res: any) => {
            if (res) {
              this.member = res.customer;
              this.print();
              this.messageService.clear();
              this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Member Fee Submitted' });
            } else {
              this.messageService.clear();
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
            }
          },
            (error) => {
              this.messageService.clear();
              this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
            });
        } else {
          this.messageService.clear();
          this.messageService.add({ severity: 'warn', summary: 'Warning Message', detail: 'Monthly Fee Must be greater then zero.' });
        }
      }
    });

  }
  clear() {
    this.member = new IMember();
    this.member.contactDetail = new IMemberContact();
    this.searchLocal("", "");
  }
  searchLocal(value, type) {
    let matchedName = [];
    let matchedTagNumber = [];
    let matchedContact = [];
    let matchedEmail = [];
    if (value !== null && value !== undefined && value.toString().length > 0) {
      if (value == "") {
        this.members = Object.assign([], this.sourceMembers);
      }
      if (!value) {
        this.members = Object.assign([], this.sourceMembers);
      }
      if (value != "") {
        if (type === "tagNumber") {
          matchedContact = Object.assign([], this.sourceMembers).filter(
            cust => cust.tagNumber ? cust.tagNumber.indexOf(value) > -1 : null);
        } else if (type === "contact") {
          matchedTagNumber = Object.assign([], this.sourceMembers).filter(
            cust => cust.contactDetail.contact ? cust.contactDetail.contact.indexOf(value) > -1 : null);
        } else {
          matchedName = Object.assign([], this.sourceMembers).filter(
            cust => cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);

          matchedEmail = Object.assign([], this.sourceMembers).filter(
            cust => cust.email ? cust.email.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
        }
        const distinct = (value, index, self) => {
          return self.indexOf(value) === index;
        }
        const source = matchedName.concat(matchedTagNumber, matchedContact, matchedEmail);
        this.members = source.filter(distinct);

        if (this.members.length === 0) {
          this.members = [];
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        } else {
          this.members = [...this.members];
        }
      }
    } else {
      this.members = Object.assign([], this.sourceMembers);
      this.members = [...this.members];
    }
  }
  DeleteMember(member) {
    let members = [...this.members];
    let index = this.members.indexOf(member);
    if (index > -1) {
      members.splice(index, 1);
      return this.members = members;
    }
  }
  print(): void {
    let printContents, popupWin;
    let currentDate=new Date();
    this.branch.name= this.branch.name+ " " + currentDate.getDate()+ "/" + (currentDate.getMonth() + 1) + "/" + currentDate.getFullYear();
    printContents = document.getElementById('invoice').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
    <html>
    <head>
        <title>${this.branch.name}</title>
        <style>
            .invoice-box {
                max-width: 800px;
                margin: auto;
                padding: 30px;
                border: 1px solid #eee;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                font-size: 16px;
                line-height: 24px;
                font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                color: #555;
            }

            .invoice-box table {
                width: 100%;
                line-height: inherit;
                text-align: left;
            }

            .invoice-box table td {
                padding: 5px;
                vertical-align: top;
            }

            .invoice-box table tr td:nth-child(n + 2) {
                text-align: right;
            }

            .invoice-box table tr.top table td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.top table td.title {
                font-size: 45px;
                line-height: 45px;
                color: #333;
            }

            .invoice-box table tr.information table td {
                padding-bottom: 40px;
            }

            .invoice-box table tr.heading td {
                background: #eee;
                border-bottom: 1px solid #ddd;
                font-weight: bold;
            }

            .invoice-box table tr.details td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.item td {
                border-bottom: 1px solid #eee;
            }
            .invoice-box table tr.item.last td {
                border-bottom: none;
            }
            .invoice-box table tr.item input {
                padding-left: 5px;
            }
            .invoice-box table tr.item td:first-child input {
                margin-left: -5px;
                width: 100%;
            }
            .invoice-box table tr.total td:nth-child(2) {
                border-top: 2px solid #eee;
                font-weight: bold;
            }
            .invoice-box input[type="number"] {
                width: 60px;
            }
            @media only screen and (max-width: 600px) {
                .invoice-box table tr.top table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }

                .invoice-box table tr.information table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }
            }
            .rtl {
                direction: rtl;
                font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                    sans-serif;
            }
            .rtl table {
                text-align: right;
            }
            .rtl table tr td:nth-child(2) {
                text-align: left;
            }
        </style>
    </head>
    <body>
        ${printContents}</body>
    </html>
    `
    );
  }
}
